import axios from "../http";

let module = "/studentRecords";

function addStudentRecords(data) {
    return axios.post(module, data);
}

function getStudentRecords(data) {
    return axios.post(module+"/query", data);
}

function lookPic(data) {
    return axios.get(module+"/file/"+data);
}

function conditionTable(data) {
    return axios.post(module+"/conditionTable",data);
}

function haveRead(data) {
    return axios.post(module+"/haveRead/"+data.recordId);
}

function addOuterRecords(data) {
    return axios.post(module+"/outer",data);
}

export default {
    addStudentRecords,
    getStudentRecords,
    lookPic,
    conditionTable,
    haveRead,
    addOuterRecords,
}
